import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { T } from "services/lang/LanguageService";
import React, { useState } from "react";
import ColorPicker from "components/basic/color-picker/ColorPicker";
import { ColorKey, EditBasicCellDialogProps, ICellConfig } from "../UniversalDatasetTableTypes";

export const defaultHighlightColor = {
  defaultTextColor: "#000000",
  defaultBackgroundColor: "#FFFFFF",
};

const EditBasicCellDialog = ({
  isEditBasicCellDialogVisible,
  setIsEditBasicCellDialogVisible,
  selectedCell,
  updateSelectedCell,
}: EditBasicCellDialogProps) => {
  const [localCellConfig, setLocalCellConfig] = useState<ICellConfig>({
    ...selectedCell,
    highlightColor: {
      color: selectedCell.highlightColor?.color ?? defaultHighlightColor.defaultTextColor,
      bgColor: selectedCell.highlightColor?.bgColor ?? defaultHighlightColor.defaultBackgroundColor,
    },
  });

  const handleColorChange = (key: ColorKey, value: string) => {
    setLocalCellConfig(prev => ({
      ...prev,
      highlightColor: {
        ...prev.highlightColor,
        [key]: value,
      },
    }));
  };

  const handleSave = () => {
    updateSelectedCell(localCellConfig);
    setIsEditBasicCellDialogVisible(false);
  };

  return (
    <Dialog
      visible={isEditBasicCellDialogVisible}
      onHide={() => setIsEditBasicCellDialogVisible(false)}
      header={T("header.edit-basic-cell")}
      footer={
        <div>
          <Button
            label="Cancel"
            className="p-button-text"
            onClick={() => setIsEditBasicCellDialogVisible(false)}
          />
          <Button label={T("action.save")} className="p-button-success" onClick={handleSave} />
        </div>
      }
    >
      <div className="flex flex-row gap-3">
        <div className="flex flex-column gap-2 align-items-left">
          <span>{T("word.text-color")}</span>
          <ColorPicker
            value={localCellConfig.highlightColor?.color}
            onValueChange={e => handleColorChange(ColorKey.COLOR, e.target.value)}
          />
        </div>
        <div className="flex flex-column gap-2 align-items-left">
          <span>{T("word.background-color")}</span>
          <ColorPicker
            value={localCellConfig.highlightColor?.bgColor}
            onValueChange={e => handleColorChange(ColorKey.BG_COLOR, e.target.value)}
          />
        </div>
      </div>
      <div className="flex justify-content-center mt-3">
        <span
          className="p-2"
          style={{
            color: localCellConfig.highlightColor?.color,
            backgroundColor: localCellConfig.highlightColor?.bgColor,
            border: "1px solid #ccc",
            borderRadius: "4px",
          }}
        >
          {T("word.preview")}
        </span>
      </div>
    </Dialog>
  );
};

export default EditBasicCellDialog;
